

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class InvoiceOneDocumentCodeParams extends BaseEntity
{   
    public DocumentCode: string; 
    public IsGoToPersonalDetails: boolean; 
	
}



